import { render, staticRenderFns } from "./wysiwyg-classic.vue?vue&type=template&id=011ef832&"
import script from "./wysiwyg-classic.vue?vue&type=script&lang=js&"
export * from "./wysiwyg-classic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports